import { ReactNode, Dispatch, SetStateAction } from 'react';
import {
  UseFormRegister,
  FieldValues,
  UseFormHandleSubmit,
  Control,
  UseFormReset,
  UseFormSetValue,
  UseFormGetValues,
  FormState,
  UseFormWatch,
  UseFormSetError,
  UseFormClearErrors,
  UseFormSetFocus,
  UseFormTrigger,
} from 'react-hook-form';

type FormType = {
  register: UseFormRegister<FieldValues>;
  handleSubmit: UseFormHandleSubmit<FieldValues>;
  control: Control<FieldValues, any>;
  reset: UseFormReset<FieldValues>;
  setValue: UseFormSetValue<FieldValues>;
  getValues: UseFormGetValues<FieldValues>;
  formState: FormState<FieldValues>;
  watch: UseFormWatch<FieldValues>;
  setError: UseFormSetError<FieldValues>;
  clearErrors: UseFormClearErrors<FieldValues>;
  setFocus: UseFormSetFocus<FieldValues>;
  trigger: UseFormTrigger<FieldValues>;
};

export type RelatorioRaioXVendasProviderProps = {
  children: ReactNode;
};

export type RelatorioRaioXVendasContextData = {
  formRelatorioRaioXVendas: FormType;
  departamentos: Select[];
  generalInfos: any;
  departmentInfos: any;
  departmentChartInfos: any;
  finalizadoraInfos: any;
  finalizadoraChartInfos: any;
  caixaInfos: any;
  caixaChartInfos: any;

  temporalInfos: any;
  temporalChartInfos: any;
  tabTemporal: Select;
  setTabTemporal: Dispatch<SetStateAction<Select>>;

  dtaFiltro: FormDataSelect;
  setDtaFiltro: Dispatch<SetStateAction<FormDataSelect>>;
  resetLoja: boolean;
  setResetLoja: Dispatch<SetStateAction<boolean>>;
  exib: boolean;
  setExib: Dispatch<SetStateAction<boolean>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  disabled: boolean;
  setDisabled: Dispatch<SetStateAction<boolean>>;
  tab: any;
  setTab: Dispatch<SetStateAction<any>>;
  tabDepartment: Select;
  setTabDepartment: Dispatch<SetStateAction<Select>>;
  buscaPorDepart: Select;
  setBuscaPorDepart: Dispatch<SetStateAction<Select>>;

  keyRef: any;
  handleSearch: () => void;
  handleResetForm: () => void;
  handleChangeTab: (tabName: any) => void;
  handleChangeTabDepartment: (sectionDepartment: any) => void;
  handleChangeTabTemporal: (sectionTemporal: any) => void;
  handleCancelForm: () => void;
};

export interface Select {
  value: string | number;
  label: string;
}

export interface IDepartamento {
  cod_departamento: number;
  descricao: string;
  des_departamento: string;
  cod_tipo_item: number;
  des_tipo_item: string;
  cod_id_ctb: number;
}
export interface FormDataSelect {
  dta_filtro_ini: {
    value: any;
    isInvalid: boolean;
    isRequired: boolean;
  };
  dta_filtro_fim: {
    value: any;
    isInvalid: boolean;
    isRequired: boolean;
  };
}

export const buscaDepartamento = [
  { value: 1, label: 'Seção' },
  { value: 2, label: 'Grupo' },
  { value: 3, label: 'SubGrupo' },
];
